import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PolicyPage from "../pages/policy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/policy",
    element: <PolicyPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
